var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6656 12.1249C23.7306 12.0699 21.8056 12.0149 18.8906 12.0149H18.5056C15.7006 12.0149 13.8306 12.0699 12.8956 12.1799C11.6306 12.2899 10.7506 12.6199 10.2556 13.0599C9.81562 13.4449 9.48563 14.1599 9.37563 15.0949C9.32063 15.6999 9.26562 16.9649 9.26562 18.8899V19.1649C9.26562 20.9799 9.32062 22.2449 9.43062 22.8499C9.59562 23.7299 9.87065 24.3899 10.4206 24.7749C10.9706 25.2149 11.9056 25.4899 13.2256 25.5999C14.1606 25.6549 16.0856 25.7099 19.0006 25.7099H19.3856C22.1906 25.7099 24.0606 25.6549 24.9956 25.5449C26.2606 25.4349 27.1406 25.1049 27.6356 24.6649C28.0756 24.2799 28.4056 23.5649 28.5156 22.6299C28.5706 22.0249 28.6256 20.7599 28.6256 18.8349V18.5599C28.6256 16.7449 28.5706 15.4799 28.4606 14.8749C28.2956 13.9949 28.0206 13.3349 27.4706 12.9499C26.9206 12.5099 25.9856 12.2349 24.6656 12.1249ZM22.5206 18.8899L16.4706 22.5199V15.2599L22.5206 18.8899Z",
    fill: "#F3F3F3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 9.5,
    stroke: "#F3F3F3",
    strokeOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bd15d9022330eb770023cc7234fd9304.svg";
export { ForwardRef as ReactComponent };